import { handleActions } from 'redux-actions'
import { openOrCloseListNest } from '../actions/lists'
import { ListsState } from '../types/states'
import { Action } from './types'

const initialState: ListsState = {
  nestedLists: {}
}

const lists = handleActions(
  {
    [openOrCloseListNest]: (
      state,
      {
        payload: { listName, id, isOpen }
      }: Action<{ listName: string; id: string; isOpen: boolean }>
    ) => ({
      ...state,
      nestedLists: {
        ...state.nestedLists,
        [listName]: {
          id,
          isOpen
        }
      }
    })
  },
  initialState
)

export default lists
